module.exports = __webpack_public_path__ + "img/shop_plate_character.def391f3.jpg";